import React from 'react';
import { DesktopLandingGifItem } from '@modules/Landing/Shared/Interfaces/DesktopLandingGifItem';
import { CategoryItem } from '@shared/Features/DesktopLandingGifsSection/CategoriesList/CategoryItem/CategoryItem';
import css from './CategoriesList.module.css';

interface CategoriesListProps {
    items: DesktopLandingGifItem[];
    activeCategoryIndex: number;
    setActiveCategoryIndex: React.Dispatch<React.SetStateAction<number>>;
}

export const CategoriesList: React.FC<CategoriesListProps> = ({
    items,
    setActiveCategoryIndex,
    activeCategoryIndex,
}) => {
    return (
        <section className={css.itemsList}>
            {items.map((item, index) => (
                <CategoryItem
                    item={item}
                    key={index}
                    itemIndex={index + 1}
                    isActive={index === activeCategoryIndex}
                    onClick={() => setActiveCategoryIndex(index)}
                />
            ))}
        </section>
    );
};
